import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class CarouselQueryService {
    public GET_CAROUSELS: any;

    constructor(public apollo: Apollo) {
        this.GET_CAROUSELS =
            gql`
            query {                           
                allCarousels {
                  edges {
                    node {
                        content
                    }
                  }
                }
              }
        `
    }

    //get charge percentage
    GET_ALL_CAROUSELS() {

        return this.apollo
            .watchQuery({
                query: this.GET_CAROUSELS
                ,
                fetchPolicy: 'network-only'
            });

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/carousel.ts